// import React, { useEffect, useState } from 'react';
// import { FiSearch, FiPlus, FiTrash2, FiHash, FiCheckCircle, FiEdit2, FiSliders, FiCheck, FiShield, FiRefreshCw } from 'react-icons/fi';
// import { message } from 'antd';

// import { getAccessToken } from "../../token";
// import { API_URL } from '../../Constants';

// const FormInput = ({ label, icon: Icon, ...props }) => (
//     <div className="mb-4">
//         <label className="block text-gray-700 font-medium mb-1">{label}</label>
//         <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-white">
//             {Icon && <Icon className="text-gray-500 mr-2" />}
//             <input className="w-full outline-none bg-transparent" {...props} />
//         </div>
//     </div>
// );

// // -------------------- SUCCESS POPUP COMPONENT --------------------
// const SuccessPopup = ({ isOpen, onClose, title, desc, icon: Icon, iconColor, iconBg }) => {
//     useEffect(() => {
//         if (isOpen) {
//             const timer = setTimeout(onClose, 3000);
//             return () => clearTimeout(timer);
//         }
//     }, [isOpen, onClose]);

//     if (!isOpen) return null;

//     return (
//         <div className="fixed inset-0 flex items-center justify-center z-50 animate-fadeIn">
//             <div className="bg-black/60 absolute inset-0" onClick={onClose}></div>
//             <div className="bg-[#f0EFEB] rounded-2xl p-8 max-w-sm mx-4 transform animate-scaleIn z-50 text-center shadow-2xl border border-[#0C4550]/20">
//                 <div className={`w-16 h-16 ${iconBg} rounded-full flex items-center justify-center mx-auto mb-4 border`}>
//                     <Icon className={`${iconColor} text-2xl`} />
//                 </div>
//                 <h3 className="text-xl font-bold text-[#0C4550] mb-2">{title}</h3>
//                 <p className="text-gray-600 mb-6">{desc}</p>
//                 <button
//                     onClick={onClose}
//                     className="w-full px-6 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-bold text-sm transition-all duration-200 hover:bg-[#0A3A43] hover:scale-[1.02]"
//                 >
//                     Continue
//                 </button>
//             </div>
//         </div>
//     );
// };

// // -------------------- MAIN COMPONENT --------------------
// export const Senders = () => {
//     // --- States ---
//     const [userPeId, setUserPeId] = useState(null);
//     const [peIdInput, setPeIdInput] = useState('');
//     const [isEditingPeId, setIsEditingPeId] = useState(false);
//     const [isRegisteringPeId, setIsRegisteringPeId] = useState(false);

//     const [senders, setSenders] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
    
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [isEditingSender, setIsEditingSender] = useState(false);
//     const [editingSenderData, setEditingSenderData] = useState(null);
//     const [isLoading, setIsLoading] = useState(false);
    
//     const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//     const [popupContent, setPopupContent] = useState({});

//     const [senderForm, setSenderForm] = useState({ headerName: '' });

//     const getAuthToken = () => getAccessToken();

//     // ------------------ API CALLS ------------------

//     const fetchDltProfile = async (token) => {
//         try {
//             const res = await fetch(`${API_URL}/api/dlt/profile`, {
//                 headers: { "Authorization": `Bearer ${token}` }
//             });
//             if (res.ok) {
//                 const data = await res.json();
//                 setUserPeId(data.peId);
//                 setPeIdInput(data.peId);
//             }
//         } catch (error) {
//             console.error("No DLT profile found", error);
//         }
//     };

//     // REGISTER OR UPDATE PE ID
//     const handleSavePeId = async () => {
//         if (!peIdInput.trim()) {
//             message.error("Please enter a valid PE ID.");
//             return;
//         }
//         setIsRegisteringPeId(true);
//         try {
//             const token = getAuthToken();
//             // Use PUT if updating, POST if registering new
//             const method = userPeId ? 'PUT' : 'POST';
            
//             const res = await fetch(`${API_URL}/api/dlt/pe-id`, {
//                 method: method,
//                 headers: { 
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}` 
//                 },
//                 body: JSON.stringify({ peId: peIdInput })
//             });

//             if (res.ok) {
//                 const data = await res.json();
//                 setUserPeId(data.peId);
//                 setIsEditingPeId(false);
//                 message.success(`PE ID successfully ${userPeId ? 'updated' : 'registered'}!`);
//             } else {
//                 const err = await res.json();
//                 message.error(err.message || "Failed to save PE ID.");
//             }
//         } catch (error) {
//             message.error("Network error while saving PE ID.");
//         }
//         setIsRegisteringPeId(false);
//     };

//     const fetchSenders = async (token) => {
//         try {
//             const res = await fetch(`${API_URL}/api/dlt/sender-ids`, {
//                 headers: { "Authorization": `Bearer ${token}` }
//             });
//             if (res.ok) {
//                 const data = await res.json();
//                 setSenders(data);
//             }
//         } catch (error) {
//             message.error("Failed to fetch headers.");
//         }
//     };

//     // CREATE OR UPDATE SENDER HEADER
//     const handleSubmitSender = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         if (!senderForm.headerName) {
//             message.error('Please enter a Header Name.');
//             setIsLoading(false);
//             return;
//         }

//         try {
//             const token = getAuthToken();
//             const url = isEditingSender 
//                 ? `${API_URL}/api/dlt/sender-ids/${editingSenderData.header}` 
//                 : `${API_URL}/api/dlt/sender-ids`;
                
//             const method = isEditingSender ? 'PUT' : 'POST';

//             const res = await fetch(url, {
//                 method: method,
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 body: JSON.stringify({ header: senderForm.headerName }) 
//             });

//             if (res.ok) {
//                 await fetchSenders(token); // Refresh list
//                 setIsModalOpen(false);
//                 setPopupContent({
//                     title: isEditingSender ? "Header Updated!" : "Header Created!",
//                     desc: isEditingSender ? "Your sender header has been updated." : "Your new sender header has been successfully linked.",
//                     icon: isEditingSender ? FiRefreshCw : FiCheck,
//                     iconBg: isEditingSender ? "bg-blue-100 border-blue-200" : "bg-emerald-100 border-emerald-200",
//                     iconColor: isEditingSender ? "text-blue-600" : "text-emerald-600"
//                 });
//                 setShowSuccessPopup(true);
//             } else {
//                 const err = await res.json();
//                 message.error(err.message || "Failed to save sender header.");
//             }
//         } catch (error) {
//             message.error("Network error while saving sender.");
//         }
//         setIsLoading(false);
//     };

//     const handleDelete = async (header) => {
//         if (!window.confirm(`Are you sure you want to delete header '${header}'?`)) return;
//         try {
//             const token = getAuthToken();
//             const res = await fetch(`${API_URL}/api/dlt/sender-ids/${header}`, {
//                 method: 'DELETE',
//                 headers: { 'Authorization': `Bearer ${token}` }
//             });

//             if (res.ok) {
//                 setSenders(prev => prev.filter(s => s.header !== header));
//                 message.success('Header deleted successfully!');
//             } else {
//                 message.error("Failed to delete header.");
//             }
//         } catch (error) {
//             message.error("Network error.");
//         }
//     };

//     const openEditModal = (sender) => {
//         setIsEditingSender(true);
//         setEditingSenderData(sender);
//         setSenderForm({ headerName: sender.header });
//         setIsModalOpen(true);
//     };

//     const closeModal = () => {
//         setIsModalOpen(false);
//         setIsEditingSender(false);
//         setEditingSenderData(null);
//         setSenderForm({ headerName: '' });
//     };

//     // --- Effects ---
//     useEffect(() => {
//         const token = getAuthToken();
//         if (token) {
//             fetchDltProfile(token);
//             fetchSenders(token);
//         }
//     }, []);

//     const filteredSenders = senders.filter(sender =>
//         sender.header?.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     return (
//         <div className="min-h-screen bg-[#f0EFEB] p-6 font-sans">
//             <div className="max-w-7xl mx-auto">
                
//                 {/* Header Section */}
//                 <div className="flex items-center gap-4 mb-8">
//                     <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center border border-[#0C4550]/30 shadow-sm">
//                         <FiShield className="text-[#0C4550] text-xl" />
//                     </div>
//                     <div>
//                         <h1 className="text-3xl font-bold text-[#0C4550]">DLT Configuration</h1>
//                         <p className="text-medium text-gray-600 mt-1 flex items-center gap-2">
//                             <FiSliders size={14} /> Manage your Principal Entity ID and Sender Headers.
//                         </p>
//                     </div>
//                 </div>

//                 {/* --- SECTION 1: PE ID REGISTRATION & EDITING --- */}
//                 <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm mb-8">
//                     <h2 className="text-xl font-bold text-[#0C4550] mb-4">Principal Entity (PE) ID</h2>
                    
//                     {userPeId && !isEditingPeId ? (
//                         <div className="flex items-center justify-between bg-emerald-50 p-4 rounded-xl border border-emerald-200">
//                             <div className="flex items-center gap-4">
//                                 <FiCheckCircle className="text-emerald-500 text-2xl" />
//                                 <div>
//                                     <p className="text-sm text-emerald-800 font-semibold">Registered PE ID</p>
//                                     <p className="text-lg font-mono text-emerald-900">{userPeId}</p>
//                                 </div>
//                             </div>
//                             <button 
//                                 onClick={() => setIsEditingPeId(true)}
//                                 className="flex items-center gap-2 px-4 py-2 bg-white border border-emerald-200 text-emerald-700 rounded-lg hover:bg-emerald-100 transition-all font-semibold"
//                             >
//                                 <FiEdit2 /> Edit
//                             </button>
//                         </div>
//                     ) : (
//                         <div className="flex flex-col md:flex-row items-end gap-4">
//                             <div className="flex-1 w-full">
//                                 <FormInput
//                                     label="Register your 19-digit DLT PE ID"
//                                     value={peIdInput}
//                                     onChange={(e) => setPeIdInput(e.target.value)}
//                                     placeholder="e.g. 1001555123456789012"
//                                     icon={FiHash}
//                                 />
//                             </div>
//                             <div className="flex gap-2 mb-4">
//                                 {userPeId && (
//                                     <button
//                                         onClick={() => { setIsEditingPeId(false); setPeIdInput(userPeId); }}
//                                         className="px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-xl font-bold transition-all hover:bg-gray-50"
//                                     >
//                                         Cancel
//                                     </button>
//                                 )}
//                                 <button
//                                     onClick={handleSavePeId}
//                                     disabled={isRegisteringPeId}
//                                     className="px-6 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-bold transition-all hover:bg-[#0A3A43] disabled:opacity-50"
//                                 >
//                                     {isRegisteringPeId ? "Saving..." : (userPeId ? "Update PE ID" : "Save PE ID")}
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* --- SECTION 2: SENDER HEADERS --- */}
//                 <div className="mb-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
//                     <button
//                         onClick={() => {
//                             if (!userPeId) return message.warning("Please register your PE ID first.");
//                             setIsModalOpen(true);
//                         }}
//                         disabled={!userPeId}
//                         className={`flex items-center gap-2 px-6 py-3.5 rounded-xl font-bold text-[16px] transition-all duration-300 ${
//                             userPeId ? 'bg-[#0C4550] text-white hover:bg-[#0A3A43] hover:scale-[1.02]' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                         }`}
//                     >
//                         <FiPlus size={18} />
//                         <span>Add Sender Header</span>
//                     </button>

//                     <div className="relative w-full lg:w-96">
//                         <input
//                             type="text"
//                             placeholder="Search headers..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-gray-300 focus:ring-2 focus:ring-[#126673] outline-none"
//                         />
//                         <FiSearch size={20} className="absolute inset-y-0 left-4 top-4 text-[#0C4550]" />
//                     </div>
//                 </div>

//                 {/* Senders Table */}
//                 <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
//                     <table className="w-full text-left">
//                         <thead className="bg-[#0C4550]/5 border-b border-gray-200 text-xs font-bold text-[#0C4550] uppercase tracking-wider">
//                             <tr>
//                                 <th className="py-5 px-8">Header Name</th>
//                                 <th className="py-5 px-8">Linked PE ID</th>
//                                 <th className="py-5 px-8 text-center w-32">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className="divide-y divide-gray-100">
//                             {filteredSenders.map((sender, idx) => (
//                                 <tr key={idx} className="hover:bg-[#0C4550]/5 transition-all">
//                                     <td className="py-5 px-8 font-semibold text-gray-800">{sender.header}</td>
//                                     <td className="py-5 px-8 font-mono text-sm text-gray-600">{sender.peId}</td>
//                                     <td className="py-5 px-8 text-center flex justify-center gap-2">
//                                         <button
//                                             onClick={() => openEditModal(sender)}
//                                             className="p-2 text-[#0C4550] hover:bg-gray-100 rounded-lg transition-all"
//                                         >
//                                             <FiEdit2 size={18} />
//                                         </button>
//                                         <button
//                                             onClick={() => handleDelete(sender.header)}
//                                             className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-all"
//                                         >
//                                             <FiTrash2 size={18} />
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Create/Edit Header Modal */}
//                 {isModalOpen && (
//                     <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fadeIn">
//                         <div className="bg-[#f0EFEB] rounded-2xl w-full max-w-md">
//                             <div className="px-8 py-6 bg-[#0C4550] rounded-t-2xl">
//                                 <h2 className="text-xl font-bold text-white">{isEditingSender ? 'Edit Sender Header' : 'Add Sender Header'}</h2>
//                             </div>

//                             <form onSubmit={handleSubmitSender} className="p-8 space-y-6">
//                                 <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
//                                     <FormInput
//                                         label="Header Name"
//                                         value={senderForm.headerName}
//                                         onChange={(e) => setSenderForm({ headerName: e.target.value })}
//                                         placeholder="e.g. TXTMSS"
//                                         required
//                                     />
//                                 </div>
                                
//                                 <div className="flex gap-3">
//                                     <button type="button" onClick={closeModal} className="flex-1 py-3 bg-white border rounded-xl font-semibold">Cancel</button>
//                                     <button type="submit" disabled={isLoading} className="flex-1 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-medium">
//                                         {isLoading ? 'Saving...' : (isEditingSender ? 'Update Header' : 'Save Header')}
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 )}

//                 <SuccessPopup isOpen={showSuccessPopup} onClose={() => setShowSuccessPopup(false)} {...popupContent} />
//             </div>
//         </div>
//     );
// };



import React, { useEffect, useState } from 'react';
import { FiSearch, FiPlus, FiTrash2, FiHash, FiCheckCircle, FiEdit2, FiSliders, FiCheck, FiShield, FiRefreshCw, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { message } from 'antd';

import { getAccessToken } from "../../token";
import { API_URL } from '../../Constants';

const FormInput = ({ label, icon: Icon, ...props }) => (
    <div className="flex-1">
        <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-white">
            {Icon && <Icon className="text-gray-500 mr-2" />}
            <input className="w-full outline-none bg-transparent" {...props} />
        </div>
    </div>
);

// -------------------- SUCCESS POPUP COMPONENT --------------------
const SuccessPopup = ({ isOpen, onClose, title, desc, icon: Icon, iconColor, iconBg }) => {
    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(onClose, 3000);
            return () => clearTimeout(timer);
        }
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 animate-fadeIn">
            <div className="bg-black/60 absolute inset-0" onClick={onClose}></div>
            <div className="bg-[#f0EFEB] rounded-2xl p-8 max-w-sm mx-4 transform animate-scaleIn z-50 text-center shadow-2xl border border-[#0C4550]/20">
                <div className={`w-16 h-16 ${iconBg} rounded-full flex items-center justify-center mx-auto mb-4 border`}>
                    <Icon className={`${iconColor} text-2xl`} />
                </div>
                <h3 className="text-xl font-bold text-[#0C4550] mb-2">{title}</h3>
                <p className="text-gray-600 mb-6">{desc}</p>
                <button
                    onClick={onClose}
                    className="w-full px-6 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-bold text-sm transition-all duration-200 hover:bg-[#0A3A43] hover:scale-[1.02]"
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

// -------------------- MAIN COMPONENT --------------------
export const Senders = () => {
    // --- States ---
    const [userPeId, setUserPeId] = useState(null);
    const [peIdInput, setPeIdInput] = useState('');
    const [isEditingPeId, setIsEditingPeId] = useState(false);
    const [isRegisteringPeId, setIsRegisteringPeId] = useState(false);

    const [senders, setSenders] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditingSender, setIsEditingSender] = useState(false);
    const [editingSenderData, setEditingSenderData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [popupContent, setPopupContent] = useState({});

    const [senderForm, setSenderForm] = useState({ headerName: '' });

    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const getAuthToken = () => getAccessToken();

    // ------------------ API CALLS ------------------

    const fetchDltProfile = async (token) => {
        try {
            const res = await fetch(`${API_URL}/api/dlt/profile`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setUserPeId(data.peId);
                setPeIdInput(data.peId);
            }
        } catch (error) {
            console.error("No DLT profile found", error);
        }
    };

    const handleSavePeId = async () => {
        if (!peIdInput.trim()) {
            message.error("Please enter a valid PE ID.");
            return;
        }
        setIsRegisteringPeId(true);
        try {
            const token = getAuthToken();
            const method = userPeId ? 'PUT' : 'POST';
            
            const res = await fetch(`${API_URL}/api/dlt/pe-id`, {
                method: method,
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                },
                body: JSON.stringify({ peId: peIdInput })
            });

            if (res.ok) {
                const data = await res.json();
                setUserPeId(data.peId);
                setIsEditingPeId(false);
                message.success(`PE ID successfully ${userPeId ? 'updated' : 'registered'}!`);
            } else {
                const err = await res.json();
                message.error(err.message || "Failed to save PE ID.");
            }
        } catch (error) {
            message.error("Network error while saving PE ID.");
        }
        setIsRegisteringPeId(false);
    };

    const fetchSenders = async (token) => {
        try {
            const res = await fetch(`${API_URL}/api/dlt/sender-ids`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                // Sorting by newest first (assuming items have an 'id' or 'createdAt' or just reverse the array)
                // We reverse the array to ensure recent additions are at the top
                setSenders(data.reverse());
            }
        } catch (error) {
            message.error("Failed to fetch headers.");
        }
    };

    const handleSubmitSender = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!senderForm.headerName) {
            message.error('Please enter a Header Name.');
            setIsLoading(false);
            return;
        }

        try {
            const token = getAuthToken();
            const url = isEditingSender 
                ? `${API_URL}/api/dlt/sender-ids/${editingSenderData.header}` 
                : `${API_URL}/api/dlt/sender-ids`;
                
            const method = isEditingSender ? 'PUT' : 'POST';

            const res = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ header: senderForm.headerName }) 
            });

            if (res.ok) {
                await fetchSenders(token);
                setIsModalOpen(false);
                setPopupContent({
                    title: isEditingSender ? "Header Updated!" : "Header Created!",
                    desc: isEditingSender ? "Your sender header has been updated." : "Your new sender header has been successfully linked.",
                    icon: isEditingSender ? FiRefreshCw : FiCheck,
                    iconBg: isEditingSender ? "bg-blue-100 border-blue-200" : "bg-emerald-100 border-emerald-200",
                    iconColor: isEditingSender ? "text-blue-600" : "text-emerald-600"
                });
                setShowSuccessPopup(true);
                setCurrentPage(1); // Return to first page to see new entry
            } else {
                const err = await res.json();
                message.error(err.message || "Failed to save sender header.");
            }
        } catch (error) {
            message.error("Network error while saving sender.");
        }
        setIsLoading(false);
    };

    const handleDelete = async (header) => {
        if (!window.confirm(`Are you sure you want to delete header '${header}'?`)) return;
        try {
            const token = getAuthToken();
            const res = await fetch(`${API_URL}/api/dlt/sender-ids/${header}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (res.ok) {
                setSenders(prev => prev.filter(s => s.header !== header));
                message.success('Header deleted successfully!');
            } else {
                message.error("Failed to delete header.");
            }
        } catch (error) {
            message.error("Network error.");
        }
    };

    const openEditModal = (sender) => {
        setIsEditingSender(true);
        setEditingSenderData(sender);
        setSenderForm({ headerName: sender.header });
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsEditingSender(false);
        setEditingSenderData(null);
        setSenderForm({ headerName: '' });
    };

    useEffect(() => {
        const token = getAuthToken();
        if (token) {
            fetchDltProfile(token);
            fetchSenders(token);
        }
    }, []);

    // Filter Logic
    const filteredSenders = senders.filter(sender =>
        sender.header?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredSenders.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredSenders.length / itemsPerPage);

    return (
        <div className="min-h-screen bg-[#f0EFEB] p-6 font-sans">
            <div className="max-w-7xl mx-auto">
                
                {/* Header Section */}
                <div className="flex items-center gap-4 mb-6">
                    <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center border border-[#0C4550]/30 shadow-sm">
                        <FiShield className="text-[#0C4550] text-lg" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-[#0C4550]">DLT Configuration</h1>
                        <p className="text-sm text-gray-600 flex items-center gap-2">
                            <FiSliders size={12} /> Manage PE ID and Sender Headers.
                        </p>
                    </div>
                </div>

                {/* --- SECTION 1: COMPACT PE ID BOX --- */}
                <div className="bg-white rounded-xl px-5 py-3 border border-gray-200 shadow-sm mb-6">
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                        <div className="flex items-center gap-3">
                             <h2 className="text-sm font-bold text-[#0C4550] uppercase tracking-wider whitespace-nowrap">Principal Entity ID:</h2>
                             {userPeId && !isEditingPeId && (
                                <div className="flex items-center gap-2 bg-emerald-50 px-3 py-1 rounded-lg border border-emerald-100">
                                    <FiCheckCircle className="text-emerald-500" />
                                    <span className="font-mono font-bold text-emerald-900">{userPeId}</span>
                                </div>
                             )}
                        </div>

                        {userPeId && !isEditingPeId ? (
                             <button 
                                onClick={() => setIsEditingPeId(true)}
                                className="flex items-center gap-2 px-4 py-1.5 bg-white border border-gray-200 text-[#0C4550] rounded-lg hover:bg-gray-50 transition-all font-semibold text-sm"
                            >
                                <FiEdit2 size={14}/> Edit PE ID
                            </button>
                        ) : (
                            <div className="flex flex-1 items-center gap-2 max-w-2xl">
                                <FormInput
                                    value={peIdInput}
                                    onChange={(e) => setPeIdInput(e.target.value)}
                                    placeholder="Enter 19-digit PE ID"
                                    icon={FiHash}
                                />
                                <div className="flex gap-2">
                                    {userPeId && (
                                        <button
                                            onClick={() => { setIsEditingPeId(false); setPeIdInput(userPeId); }}
                                            className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg text-sm font-bold hover:bg-gray-50"
                                        >
                                            Cancel
                                        </button>
                                    )}
                                    <button
                                        onClick={handleSavePeId}
                                        disabled={isRegisteringPeId}
                                        className="px-4 py-2 bg-[#0C4550] text-[#C5F637] rounded-lg text-sm font-bold hover:bg-[#0A3A43] disabled:opacity-50 whitespace-nowrap"
                                    >
                                        {isRegisteringPeId ? "Saving..." : "Save ID"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* --- SECTION 2: SENDER HEADERS --- */}
                <div className="mb-6 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                    <button
                        onClick={() => {
                            if (!userPeId) return message.warning("Please register your PE ID first.");
                            setIsModalOpen(true);
                        }}
                        disabled={!userPeId}
                        className={`flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-[15px] transition-all duration-300 ${
                            userPeId ? 'bg-[#0C4550] text-white hover:bg-[#0A3A43] hover:scale-[1.01]' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                    >
                        <FiPlus size={18} />
                        <span>Add Sender Header</span>
                    </button>

                    <div className="relative w-full lg:w-80">
                        <input
                            type="text"
                            placeholder="Search headers..."
                            value={searchTerm}
                            onChange={(e) => {setSearchTerm(e.target.value); setCurrentPage(1);}}
                            className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-gray-300 focus:ring-2 focus:ring-[#126673] outline-none text-sm"
                        />
                        <FiSearch size={18} className="absolute inset-y-0 left-3 top-3 text-[#0C4550]" />
                    </div>
                </div>

                {/* Senders Table */}
                <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
                    <table className="w-full text-left">
                        <thead className="bg-[#0C4550]/5 border-b border-gray-200 text-xs font-bold text-[#0C4550] uppercase tracking-wider">
                            <tr>
                                <th className="py-4 px-8">Header Name</th>
                                <th className="py-4 px-8">Linked PE ID</th>
                                <th className="py-4 px-8 text-center w-32">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {currentItems.length > 0 ? currentItems.map((sender, idx) => (
                                <tr key={idx} className="hover:bg-[#0C4550]/5 transition-all">
                                    <td className="py-4 px-8 font-semibold text-gray-800">{sender.header}</td>
                                    <td className="py-4 px-8 font-mono text-sm text-gray-600">{sender.peId}</td>
                                    <td className="py-4 px-8 text-center flex justify-center gap-2">
                                        <button
                                            onClick={() => openEditModal(sender)}
                                            className="p-2 text-[#0C4550] hover:bg-gray-100 rounded-lg transition-all"
                                        >
                                            <FiEdit2 size={16} />
                                        </button>
                                        <button
                                            onClick={() => handleDelete(sender.header)}
                                            className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-all"
                                        >
                                            <FiTrash2 size={16} />
                                        </button>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="3" className="py-10 text-center text-gray-400">No headers found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                        <div className="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-between">
                            <span className="text-sm text-gray-500">
                                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredSenders.length)} of {filteredSenders.length}
                            </span>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                    className="p-2 rounded-lg border border-gray-300 disabled:opacity-30 hover:bg-white transition-all"
                                >
                                    <FiChevronLeft />
                                </button>
                                <div className="flex items-center px-4 text-sm font-bold text-[#0C4550]">
                                    {currentPage} / {totalPages}
                                </div>
                                <button
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                    className="p-2 rounded-lg border border-gray-300 disabled:opacity-30 hover:bg-white transition-all"
                                >
                                    <FiChevronRight />
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* Create/Edit Header Modal */}
                {isModalOpen && (
                    <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fadeIn">
                        <div className="bg-[#f0EFEB] rounded-2xl w-full max-w-md">
                            <div className="px-8 py-5 bg-[#0C4550] rounded-t-2xl">
                                <h2 className="text-lg font-bold text-white">{isEditingSender ? 'Edit Sender Header' : 'Add Sender Header'}</h2>
                            </div>

                            <form onSubmit={handleSubmitSender} className="p-6 space-y-6">
                                <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                                    <label className="block text-gray-700 font-medium mb-1 text-sm">Header Name</label>
                                    <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-white">
                                        <FiHash className="text-gray-500 mr-2" />
                                        <input 
                                            className="w-full outline-none bg-transparent"
                                            value={senderForm.headerName}
                                            onChange={(e) => setSenderForm({ headerName: e.target.value })}
                                            placeholder="e.g. TXTMSS"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="flex gap-3">
                                    <button type="button" onClick={closeModal} className="flex-1 py-3 bg-white border rounded-xl font-semibold text-sm">Cancel</button>
                                    <button type="submit" disabled={isLoading} className="flex-1 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-bold text-sm">
                                        {isLoading ? 'Saving...' : (isEditingSender ? 'Update Header' : 'Save Header')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                <SuccessPopup isOpen={showSuccessPopup} onClose={() => setShowSuccessPopup(false)} {...popupContent} />
            </div>
        </div>
    );
};